import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SnShare } from '@lib/api/entities';

@Component({
  selector: 'sn-share-params',
  templateUrl: './sn-share-params.component.html',
  styleUrls: ['./sn-share-params.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnShareParamsComponent {
  @Input()
  public share: SnShare;

  constructor() {}
}
